import { render, staticRenderFns } from "./MachineCalling.vue?vue&type=template&id=48270dea&scoped=true"
import script from "./MachineCalling.vue?vue&type=script&lang=js"
export * from "./MachineCalling.vue?vue&type=script&lang=js"
import style0 from "./MachineCalling.vue?vue&type=style&index=0&id=48270dea&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48270dea",
  null
  
)

export default component.exports